module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-image-editor"
  }, [_c('iframe', {
    ref: "search",
    staticClass: "-iframe",
    attrs: {
      "src": _vm.src,
      "id": "iframe-mam-search"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e93f11a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/ImageLoader.vue
// module id = 678
// module chunks = 0